import { evaluateMapAccess } from "@dailywars/core/entitlements/mapAccess";
import { Lock } from "lucide-react";

import { MapPreviewImage } from "#/components/MapPreviewImage";
import { PlayMapCta } from "#/components/PlayMapCta";
import { CardContent } from "#/components/ui/card";
import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from "#/components/ui/empty";
import { mapAccessUiFlags } from "#/lib/mapAccessUi";
import { useRequestGameContext } from "#/lib/useRequestGameContext";
import { cn } from "#/lib/utils";

import { HERO_PREVIEW_BOX_PX } from "./-play.previewSizing";

export function LeaderboardMapHero({ mapId }: { mapId: string }) {
  const { entitlements } = useRequestGameContext();
  const access = evaluateMapAccess({ mapId, entitlements });
  const { isUpgradeLocked } = mapAccessUiFlags(access);

  return (
    <>
      <MapPreviewImage
        mapId={mapId}
        maxSize={HERO_PREVIEW_BOX_PX}
        fillWidth
        className={cn(
          "group rounded-xl border shadow-lg",
          isUpgradeLocked && "transition-opacity duration-150 ease-out group-hover:opacity-100",
        )}
      >
        {isUpgradeLocked ? (
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center rounded-xl bg-foreground/25 backdrop-blur-xs transition-opacity duration-150 ease-out group-hover:opacity-0">
            <Lock className="text-background" size={32} strokeWidth={2} />
          </div>
        ) : null}
      </MapPreviewImage>
      <PlayMapCta mapId={mapId} access={access} style={{ maxWidth: HERO_PREVIEW_BOX_PX }} />
    </>
  );
}

export function LeaderboardEmptyBody() {
  return (
    <CardContent className="py-12">
      <Empty className="border-0 p-0">
        <EmptyHeader>
          <EmptyTitle>No scores yet</EmptyTitle>
          <EmptyDescription>Be the first on the board.</EmptyDescription>
        </EmptyHeader>
      </Empty>
    </CardContent>
  );
}
